import React from 'react';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import { DialogContent } from './DialogContent';
import DialogHeader from './DialogHeader';
export default class StandardDialog extends React.Component {
    render() {
        const { title, onClose, closeFallbackText, message, subMessage, icon, iconModifier, style, classes, children, skipAutoFocus } = this.props;
        return (React.createElement("div", Object.assign({}, resolveTestId(this.props)),
            (title || onClose) && (React.createElement(DialogHeader, { title: title, onClose: onClose, closeFallbackText: closeFallbackText, style: style, classes: classes })),
            React.createElement(DialogContent, { message: message, subMessage: subMessage, icon: icon, iconModifier: iconModifier, style: style, classes: classes, skipAutoFocus: skipAutoFocus }, children)));
    }
}
